import { Form } from 'informed';
import { useEffect, useState } from 'react';

import { useStyle } from '@/classify';
import { SuccessDialog } from '@/components/MedicalProfessionalDiscounts/successDialog';
import { isRequired } from '@/util/formValidators';
import Button from '../../Button';
import Field from '../../Field';
import GoogleReCaptcha from '../../GoogleReCaptcha';
import TextInput from '../../TextInput';
import defaultClasses from './forgotPasswordForm.module.css';

const ForgotPasswordForm = props => {
  const classes = useStyle(defaultClasses, props.classes);
  const {
    initialValues = {},
    isResettingPassword = false,
    onSubmit,
    onCancel,
    recaptchaWidgetProps,
    hasCompleted,
    isShowBack = true,
  } = props;
  const back = () => {
    onCancel();
  };
  const [showModal, setShowModal] = useState(false);
  const [submittedEmail, setSubmittedEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit2 = value => {
    setLoading(true);
    setSubmittedEmail(value?.values?.email);
    onSubmit(value);
  };

  useEffect(() => {
    if (hasCompleted) {
      setShowModal(true);
      setLoading(false);
    }
  }, [hasCompleted]);

  return (
    <Form
      className={classes.root}
      initialValues={initialValues}
      onSubmit={onSubmit2}
    >
      <Field
        id='firstname'
        label='Email'
        classes={{
          requiredLabel: classes.requiredLabel,
        }}
        required
      >
        <TextInput
          className='w-full lg_w-[530px]'
          autoComplete='email'
          field='email'
          // placeholder='Email Address'
          validate={isRequired}
        />
      </Field>
      <GoogleReCaptcha {...recaptchaWidgetProps} />
      <div className='flex flex-col justify-start gap-[20px] lg_flex-row lg_gap-[10px]'>
        <Button
          className='duration-300 h-[40px] w-full rounded-full bg-black font-roboto-medium font-medium text-white transition-all hover_bg-[#4c4c4c] lg_h-[50px] lg_w-[170px]'
          disabled={isResettingPassword}
          type='submit'
          priority='high'
          loading={loading && isResettingPassword}
        >
          Reset Password
        </Button>
        {isShowBack ? (
          <Button
            className='duration-300  h-[40px] w-full rounded-full border-1 border-black bg-white font-roboto-medium font-medium text-black transition-all hover_bg-black hover_text-white lg_h-[50px] lg_w-[140px]'
            disabled={isResettingPassword}
            type='button'
            priority='low'
            onClick={back}
          >
            Back
          </Button>
        ) : null}
      </div>
      {showModal && (
        <SuccessDialog
          titlePc='Recover Password'
          textPc={[
            `If there is an account associated with ${submittedEmail} you will receive an email with a link to change your password.`,
          ]}
          contactText={''}
          handleClose={() => setShowModal(false)}
        />
      )}
    </Form>
  );
};

export default ForgotPasswordForm;
